import React from "react";
import { ConfigurationContextProvider } from "./ConfigurationContext";
import Configuration from "./Configuration";

const ConfigHome = (props) => {
  return (
    <ConfigurationContextProvider>
      <Configuration {...props} />
    </ConfigurationContextProvider>
  );
};

export default ConfigHome;
